/* jshint esversion: 6 */
import React from 'react';

const EverqueuePlaceholder = (props) => {

    return (
        <div className="everqueue-placeholder">
            <i className="ds-icon icon-everqueue"/>
        </div>
    );

}

EverqueuePlaceholder.displayName = "EverqueuePlaceholder";

export default EverqueuePlaceholder;
